import React from "react"
import { Container, Row, Col } from "reactstrap"
import observabilityService, { LOG_SEVERITY } from "../../services/observability_service"
import errorImg from "../../assets/images/error.png"
import NeoButton from "./NeoButton"

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        // Atualiza o estado para que a próxima renderização mostre a UI de fallback.
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        // Registra o erro no serviço de observabilidade
        observabilityService.logError(error, {
            severity: LOG_SEVERITY.CRITICAL,
            componentStack: errorInfo.componentStack,
            location: window.location.href,
        })
    }

    handleRestart = () => {
        window.location.href = "/"
    }

    render() {
        if (this.state.hasError) {
            return (
                <div 
                    className="account-pages d-flex align-items-center" 
                    style={{ 
                        fontFamily: 'Outfit, sans-serif', 
                        minHeight: "100vh", 
                        backgroundColor: "var(--color-bg-canvas)",
                        padding: "2rem 0"
                    }}
                >
                    <Container>
                        <Row className="align-items-center justify-content-between g-5">
                            {/* Coluna 1: Ilustração de erro em tamanho super expandido (Dominância visual 8/12) */}
                            <Col md={8} lg={8} className="text-center">
                                <div 
                                    className="animate__animated animate__zoomIn"
                                    style={{ 
                                        width: "100%", 
                                        maxWidth: "850px", 
                                        margin: "0 auto" 
                                    }}
                                >
                                    <img 
                                        src={errorImg} 
                                        alt="Erro inesperado" 
                                        className="img-fluid mx-auto d-block" 
                                        style={{ 
                                            width: "100%", 
                                            height: "auto", 
                                            objectFit: "contain",
                                            filter: "drop-shadow(0 12px 30px rgba(72, 39, 18, 0.1))",
                                            transition: "transform 0.3s ease"
                                        }} 
                                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.025)"}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                    />
                                </div>
                            </Col>

                            {/* Coluna 2: Textos informativos e botão com alinhamento perfeito no desktop (4/12) */}
                            <Col md={4} lg={4} className="text-center text-md-start">
                                <div 
                                    className="animate__animated animate__fadeInUp"
                                    style={{ 
                                        maxWidth: "400px",
                                        margin: "0 auto",
                                        animationDelay: "0.15s"
                                    }}
                                >
                                    <h1 
                                        className="fw-black mb-3" 
                                        style={{ 
                                            color: 'var(--color-brand-primary)', 
                                            fontSize: '3rem', 
                                            fontWeight: '900',
                                            letterSpacing: '-1.5px',
                                            lineHeight: '1.1', 
                                            fontFamily: 'Outfit, sans-serif' 
                                        }}
                                    >
                                        Ops! Algo deu errado.
                                    </h1>
                                    
                                    <p 
                                        className="mb-4 font-size-16" 
                                        style={{ 
                                            color: 'var(--color-brand-secondary)',
                                            fontWeight: '600',
                                            lineHeight: '1.65',
                                            fontFamily: 'Outfit, sans-serif'
                                        }}
                                    >
                                        Ocorreu um erro inesperado na aplicação. O administrador do sistema já foi notificado automaticamente e o erro foi registrado para análise imediata.
                                    </p>

                                    <NeoButton
                                        variant="primary"
                                        onClick={this.handleRestart}
                                        className="px-4 py-2 mt-2"
                                        size="lg"
                                        icon="mdi-arrow-left"
                                    >
                                        Voltar para o Início
                                    </NeoButton>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
